module.exports = {
  "/": {
    "name": "Root",
    "success": {
      "file preview loaded": [
        "FILE_PREVIEW_LOADED"
      ],
      "file not found": [
        "FILE_PREVIEW_NOT_FOUND"
      ]
    },
    "error": [
      "FILE_PREVIEW_FAILED"
    ]
  },
  "/file/:fileId": {
    "name": "file-preview",
    "success": {
      "file preview loaded": [
        "FILE_PREVIEW_LOADED"
      ],
      "file not found": [
        "FILE_PREVIEW_NOT_FOUND"
      ]
    },
    "error": [
      "FILE_PREVIEW_FAILED"
    ]
  }
};